export const toggleInfo = () => {
  
  const toggleButton = document.querySelector('.js-info-toggle');
  const headerText = document.querySelector('.js-header-text');
  const toggleText = document.querySelector('.c-site-header__info-toggle-text');
  
  if (!toggleButton || !headerText) return;
  
  const init = () => {
    bind();
  };

  const bind = () => {
    toggleButton.addEventListener('click', handleToggle);
  };

  const handleToggle = (e) => {
    e.preventDefault();
    
    const isVisible = headerText.classList.contains('is-visible');
    
    if (isVisible) {
      // Hide the text
      headerText.classList.remove('is-visible');
      toggleText.textContent = 'Info +';
      toggleButton.setAttribute('aria-expanded', 'false');
    } else {
      // Show the text
      headerText.classList.add('is-visible');
      toggleText.textContent = 'Info −';
      toggleButton.setAttribute('aria-expanded', 'true');
    }
  };

  init();
};
